import React from "react";

import TableAdd from "../simple/TableAdd";
import {
  AccountingCodeInput,
  AddableSelectBox,
  AddUnit,
  BarcodeInput,
  ButtonInput,
  CheckBoxInput,
  CommissionInput,
  ConditionalPriceInput,
  CurrencyInput,
  DatePickerInput,
  DescriptionFields,
  Divider,
  ImagePickerInput,
  OptionalDescription,
  PercentInput,
  PersonTypeInput,
  RadioInput,
  SecondaryUnit,
  SelectBox,
  StatusInput,
  SwitchableTextInput,
  TextAreaInput,
  TextInput,
} from "./index";
import { useSelector } from "react-redux";

export const RenderFormInputs = (form) => {
  let formInputs = [];
  form.inputs.map((input, key) => {
    formInputs.push(
      input.type === "secondaryUnit" ? (
        <RenderInput input={input} />
      ) : (
        <div
          className={input.outerWrapperClass ? input.outerWrapperClass : input.wrapperClass ?? "col-lg-12 col-md-12 col-sm-12 col-xs-12"}
          style={input.style ? input.style : null}
        >
          <RenderInput input={input} />
        </div>
      )
    );
  });

  return formInputs;
};

export const RenderFactorInputs = ({ form }) => {
  let formInputs = [];
  form.map((input, key) => {
    if (input.type === "factorTable") {
      formInputs.push(<RenderInput input={input} />);
    } else {
      formInputs.push(
        <div className={input.outerWrapperClass ?? ""}>
          <RenderInput input={input} />
        </div>
      );

    }
  });

  return formInputs;
};

export const RenderInput = (props) => {
  const editItem = useSelector((state) => state.formReducer.editItem);
  const textInputTypes = ["text", "number", "price"];
  let input = props.input;
  let disabled = false;
  if (input.disableOnEdit && !!editItem) {
    disabled = true;
  }
  if (!input.type || textInputTypes.includes(input.type)) {
    return <TextInput {...{ input, disabled }} />;
  } else if (input.type === "barcode") {
    return <BarcodeInput {...{ input, disabled }} />;
  } else if (input.type === "textarea") {
    return <TextAreaInput {...{ input, disabled }} />;
  } else if (input.type === "category") {
    return <AddableSelectBox {...{ input, disabled }} />;
  } else if (input.type === "currency") {
    return <CurrencyInput {...{ input, disabled }} />;
  } else if (input.type === "optionalDescription") {
    return <OptionalDescription {...{ input, disabled }} />;
  } else if (input.type === "accountingCode") {
    return <AccountingCodeInput {...{ input, disabled }} />;
  } else if (input.type === "imagePicker") {
    return <ImagePickerInput {...{ input, disabled }} />;
  } else if (input.type === "status") {
    return <StatusInput {...{ input, disabled }} />;
  } else if (input.type === "divider") {
    return <Divider {...{ input, disabled }} />;
  } else if (input.type === "addUnit") {
    return <AddUnit {...{ input, disabled }} />;
  } else if (input.type === "secondaryUnit") {
    return <SecondaryUnit {...{ input, disabled }} />;
  } else if (input.type === "radioInput") {
    return <RadioInput {...{ input, disabled }} />;
  } else if (input.type === "selectBox") {
    return <SelectBox {...{ input, disabled }} />;
  } else if (input.type === "personType") {
    return <PersonTypeInput {...{ input, disabled }} />;
  } else if (input.type === "datePickerInput") {
    return <DatePickerInput {...{ input, disabled }} />;
  } else if (input.type === "commissionInput") {
    return <CommissionInput {...{ input, disabled }} />;
  } else if (input.type === "checkbox") {
    return <CheckBoxInput {...{ input, disabled }} />;
  } else if (input.type === "descriptionFields") {
    return <DescriptionFields {...{ input, disabled }} />;
  } else if (input.type === "button") {
    return <ButtonInput {...{ input, disabled }} />;
  } else if (input.type === "percent") {
    return <PercentInput {...{ input, disabled }} />;
  } else if (input.type === "factorTable") {
    return <TableAdd {...{ input, disabled }} />;
  } else if (input.type === "switchableTextInput") {
    return <SwitchableTextInput titles={input} />;
  } else if (input.type === "conditionalPriceInput") {
    return <ConditionalPriceInput {...{ input, disabled }} />;
  } else if (input.type === "custom") {
    return <input.component  {...{ input, disabled }} />;

  }

  return null;
};
